module.exports = __webpack_public_path__ + "static/img/10.0b479be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/10.png
// module id = SXWe
// module chunks = 0